import ScrolledIntoView from '@carvana/stc-scrolled-into-view';
import { useEffect, Suspense } from 'react';
import { hasMobileUserAgent } from '@carvana/stc-utilities';
// @ts-ignore - No type definitions available for @carvana/header
import HeaderSkeleton from '@carvana/header';
import dynamic from 'next/dynamic';
import ErrorBoundary from '@carvana/stc-error-boundary';
import { Container, Inner } from './styles';
import Hero from './Hero';
import HeroLoadingFallback from './HeroLoadingFallback';
import Worth from './Worth';
import useAnalyticEvent from 'shared/hooks/useAnalyticEvent';
import recordAnalyticsEventMobile, { MobileAnalyticsEvents } from 'analytics/mobileAnalytics';
import { EventActions } from 'analytics/uiMetrics';
import CustomerReviews from 'components/LandingPage/CustomerReview';
import FAQSection from 'components/LandingPage/FAQs';
import Footer from 'components/Footer';
import Steps from 'components/LandingPage/Steps';
import TradeIn from 'components/LandingPage/TradeIn';
import { logError } from 'shared/utilities/dataDog';

// Load Header client-side only to avoid hydration mismatch with MFE
const Header = dynamic(() => import('components/LandingPage/Header'), {
  ssr: false,
  loading: () => <HeaderSkeleton route="/sell-my-car" />
});

const HeroFallback = () => <HeroLoadingFallback />;

const LandingPage = () => {
  const { recordGenericEvent } = useAnalyticEvent();

  useEffect(() => {
    recordGenericEvent('Landing Page', 'LandingPage', EventActions.Visited);
    recordAnalyticsEventMobile(MobileAnalyticsEvents.PageVisited, { pageName: 'Landing Page' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const nativeMobile = typeof window !== 'undefined' && hasMobileUserAgent(window.navigator);

  const handleHeroError = (err: string) =>
    logError(err, 'Hero render error', {
      pageName: 'Landing Page',
      component: 'Hero'
    });

  return (
    <Container $nativeMobile={nativeMobile}>
      <Inner>
        <Header />
        <ErrorBoundary ErrorPage={HeroFallback} onError={handleHeroError}>
          <Suspense fallback={<HeroLoadingFallback />}>
            <Hero />
          </Suspense>
        </ErrorBoundary>
        <Worth />
        <Steps />
        <ScrolledIntoView
          onFirstEnterView={() =>
            recordGenericEvent('Landing Page', 'Social Proof', EventActions.Scrolled)
          }
        >
          <CustomerReviews />
        </ScrolledIntoView>
        <FAQSection />
        <TradeIn />
        <Footer />
      </Inner>
    </Container>
  );
};

export default LandingPage;
